<template>
  <div class="FormPlainInput form-group row">
    <label class="col-md-2 text-left col-form-label" :for="uid">{{ label }}</label>
    <div class="col-sm-12 col-md-10">
      <input class="form-control-plaintext" :id="uid" v-bind="$attrs" :value="value" @input="handleInput($event.target.value)" readonly>
    </div>
    <div class="slot">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: {
      type: [String, Number, Object]
    }
  },
  computed: {
    uid () {
      return this.label + Date.now()
    }
  },
  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },
    handleClear () {
      this.$emit('input', '')
    }
  }
}
</script>

<style scoped lang="scss">
.FormPlainInput {
  position: relative;
  border-bottom: 1px solid #eef1f4;
  margin-bottom: 2rem;
  label {
    font-size: 14px;
    color: #888d9d;
    width: 94px;
    padding-left: 0;
  }
  input {
    font-size: 14px;
    color: #333;
    padding-left: 0;
    border: none;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .slot {
    position: absolute;
    font-weight: normal;
    right: 0px;
    bottom: 2px;
    outline: none;
  }
}
</style>
